import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
    dsn: "https://bfc581cdf09bec7b8bd09a84edb2baf1@o4509719080796160.ingest.de.sentry.io/4510153848586320",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true
})

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
